export const emptyGalleryImage = () => ({
    id: "",
    title: {},
    description: {},
    url: undefined,
    embedUrl: ""
});
